<fd-popover
  #popover
  placement="bottom"
  [maxWidth]="800"
  [noArrow]="false"
  [triggers]="['mouseenter', 'mouseleave']"
>
  <fd-popover-control>
    <fd-info-label
      [color]="badge.colorSchema"
      [data-testid]="'dxp-extension-trust-' + this.id"
      [glyph]="badge.icon"
      [id]="this.id"
      [label]="badge.text"
    />
  </fd-popover-control>
  <fd-popover-body>
    <div class="dxp-breadcrumb-badge-popover">{{ badge.hint }}</div>
  </fd-popover-body>
</fd-popover>
